import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import { toast } from 'react-toastify'
import clinicalCareClassifications from '@/services/api/clinicalCareClassifications'
import FormClassification from '../Form'

function Row({ classification, fetchData, onClassificationRemoved }) {
  const [removing, setRemoving] = useState(false)

  const onRemove = useCallback(async () => {
    try {
      setRemoving(true)
      await clinicalCareClassifications.destroy(classification.id)
      setRemoving(false)
      toast.success('Classificação excluída com sucesso')
      onClassificationRemoved(classification)
    } catch (e) {
      toast.error(e.message)
      setRemoving(false)
    }
  }, [onClassificationRemoved, classification])

  function onClickRemove() {
    confirmAlert({
      title: 'Excluir classificação',
      message: 'Você está certo que deseja excluir esta classificação?',
      buttons: [
        { label: 'Não' },
        {
          label: 'Sim',
          className: 'bg-error',
          onClick: onRemove,
        },
      ],
    })
  }

  return (
    <>
      <tr>
        <td>
          {classification.description}
        </td>
        <td>
          {
            classification?.priority ? (
              <span style={{
                borderRadius: 5,
                lineHeight: 1,
                textAlign: 'center',
                color: '#fff',
                padding: '3px 10px',
                fontWeight: 'bold',
                backgroundColor: classification.priority.color,
              }}
              >
                {classification.priority.title}
              </span>
            ) : (
              <span className="text-gray">-</span>
            )
          }
        </td>
        <td className="text-right">
          <FormClassification
            classification={classification}
            btnClass="btn btn-primary btn-sm btn-action"
            btnIcon="fas fa-edit"
            onApiResponse={fetchData}
          />
          <button
            type="button"
            onClick={onClickRemove}
            className={`btn btn-sm btn-error btn-action ml-1 ${removing ? 'loading' : ''}`}
            title="Excluir"
            disabled={removing}
          >
            <i className="fas fa-trash" />
          </button>
        </td>
      </tr>
    </>
  )
}

Row.propTypes = {
  fetchData: PropTypes.func.isRequired,
  onClassificationRemoved: PropTypes.func.isRequired,
  classification: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
    priorityId: PropTypes.number,
    priority: PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      color: PropTypes.string,
    }),
  }).isRequired,
}

export default Row
